module.exports = __webpack_public_path__ + "img/empty.a6ae0fc3.png";